import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { GRID_CARD_TYPES } from '../constants';
import useNumGridCols from '../hooks/useNumGridCols';

import AssetCard from './AssetCard';
import GridIndexInfo from './GridIndexInfo';
import ProductCard from './ProductCard/ProductCard';

const GridIndexInfoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.palette.white};
  width: 80%;
`;

const GridCardRendererWrapper = styled.div`
  grid-column: span ${({ $columnSpan }) => $columnSpan};
  grid-row: span ${({ $rowSpan }) => $rowSpan};
  width: 100%;
  position: relative;
`;

const StyledAssetCard = styled(AssetCard)`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  border-radius: 12px;
`;

const GridCardRendererV2 = ({
  item,
  row,
  column,
  showIndexInfo = false, // TODO: make this a FF or debug admin option
}) => {
  const numGridColumns = useNumGridCols();
  const columnSpan = item?.span?.columns || 1;
  const rowSpan = item?.span?.rows || 1;
  const gridIndex = row * numGridColumns + column;

  return (
    <GridCardRendererWrapper $columnSpan={columnSpan} $rowSpan={rowSpan}>
      {showIndexInfo && (
        <GridIndexInfoWrapper>
          <GridIndexInfo
            numGridColumns={numGridColumns}
            row={row}
            column={column}
            customVars={item?.options?.customVars}
          />
        </GridIndexInfoWrapper>
      )}
      {item?.type === GRID_CARD_TYPES.ASSET ? (
        <StyledAssetCard {...item} />
      ) : (
        <ProductCard {...item} gridIndex={gridIndex} />
      )}
    </GridCardRendererWrapper>
  );
};

GridCardRendererV2.propTypes = {
  column: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
    span: PropTypes.shape({
      rows: PropTypes.number,
      columns: PropTypes.number,
    }),
    options: PropTypes.shape({
      customVars: PropTypes.object,
    }),
  }).isRequired,
  row: PropTypes.number.isRequired,
  showIndexInfo: PropTypes.bool,
  variant: PropTypes.string,
};

export default React.memo(GridCardRendererV2);
